var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service from '@ember/service';
import Evented from '@ember/object/evented';
import { action } from '@ember/object';
import { Events, triggerEvent } from '../utils/events';
import { tracked } from '@glimmer/tracking';
import { BODY_IS_DRAGGING_CLASS } from '../utils/constants';
let FlyDragDropManager = (_class = class FlyDragDropManager extends Service.extend(Evented) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "draggableMap", {});
    _defineProperty(this, "droppableMap", {});
    _initializerDefineProperty(this, "isDragging", _descriptor, this);
    _initializerDefineProperty(this, "currentDraggableId", _descriptor2, this);
    _initializerDefineProperty(this, "currentDroppableId", _descriptor3, this);
  }
  willDestroy() {
    super.willDestroy();
    this.draggableMap = {};
    this.droppableMap = {};
    this.isDragging = false;
    this.currentDraggableId = null;
    this.currentDroppableId = null;
    document.body.classList.remove(BODY_IS_DRAGGING_CLASS);
  }
  registerDraggable(modifierInstance) {
    this.draggableMap[modifierInstance.id] = modifierInstance;
    modifierInstance.draggableElement.addEventListener(Events.DragStart, this.onDragStart);
    modifierInstance.draggableElement.addEventListener(Events.DragMove, this.onDragMove);
    modifierInstance.draggableElement.addEventListener(Events.DragEnd, this.onDragEnd);
  }
  unregisterDraggable(id) {
    if (this.draggableMap[id] == null) {
      return;
    }
    let draggableInstance = this.draggableMap[id];
    draggableInstance.draggableElement.removeEventListener(Events.DragStart, this.onDragStart);
    draggableInstance.draggableElement.removeEventListener(Events.DragMove, this.onDragMove);
    draggableInstance.draggableElement.removeEventListener(Events.DragEnd, this.onDragEnd);
    delete this.draggableMap[id];
  }
  registerDroppable(modifierInstance) {
    this.droppableMap[modifierInstance.id] = modifierInstance;
  }
  unregisterDroppable(id) {
    if (this.droppableMap[id] == null) {
      return;
    }
    delete this.droppableMap[id];
  }
  onDragStart(event) {
    this.isDragging = true;
    this.currentDraggableId = event.target?.dataset.flyDragDropId;
    document.body.classList.add(BODY_IS_DRAGGING_CLASS);
    this.trigger(Events.DragStart, event);
  }
  onDragMove(event) {
    if (!this.isDragging) {
      return;
    }
    let target = document.elementFromPoint(event.detail.clientX ?? 0, event.detail.clientY ?? 0);
    let closestDroppableElement = target?.closest('[data-fly-droppable]');
    if (!closestDroppableElement) {
      if (this.currentDroppableId) {
        this.onDragLeave(event, this.droppableMap[this.currentDroppableId].droppableElement);
      }
      return;
    }
    let droppableId = closestDroppableElement.dataset.flyDragDropId;
    let droppableItem = this.droppableMap[droppableId];
    if (droppableItem.canDrop) {
      this.onDragOver(event, closestDroppableElement);
    }
  }
  onDragEnd(event) {
    if (this.currentDroppableId) {
      this.onDrop(event, this.droppableMap[this.currentDroppableId].droppableElement);
    }
    this.isDragging = false;
    this.currentDraggableId = null;
    this.currentDroppableId = null;
    document.body.classList.remove(BODY_IS_DRAGGING_CLASS);
    this.trigger(Events.DragEnd, event);
  }
  onDragEnter(event, droppableElement) {
    if (!this.isDragging || !this.currentDraggableId) {
      return;
    }
    if (this.currentDroppableId && this.currentDroppableId !== droppableElement.dataset.flyDragDropId) {
      this.onDragLeave(event, this.droppableMap[this.currentDroppableId].droppableElement);
    }
    this.currentDroppableId = droppableElement.dataset.flyDragDropId;
    if (!this.currentDroppableId) {
      return;
    }
    let draggableItem = this.draggableMap[this.currentDraggableId];
    let droppableItem = this.droppableMap[this.currentDroppableId];
    triggerEvent(droppableElement, Events.DragEnter, {
      clientX: event.detail.clientX,
      clientY: event.detail.clientY,
      context: {
        draggableId: draggableItem.id,
        droppableId: droppableItem.id,
        draggable: draggableItem.context,
        droppable: droppableItem.context
      }
    });
    this.trigger(Events.DragEnter, event);
  }
  onDragOver(event, droppableElement) {
    if (!this.isDragging) {
      return;
    }
    if (this.currentDroppableId == null) {
      this.onDragEnter(event, droppableElement);
    } else if (this.currentDroppableId !== droppableElement.dataset.flyDragDropId) {
      this.onDragLeave(event, this.droppableMap[this.currentDroppableId].droppableElement);
      this.onDragEnter(event, droppableElement);
    }
    if (!this.currentDraggableId || !this.currentDroppableId) {
      return;
    }
    let draggableItem = this.draggableMap[this.currentDraggableId];
    let droppableItem = this.droppableMap[this.currentDroppableId];
    triggerEvent(droppableElement, Events.DragOver, {
      clientX: event.detail.clientX,
      clientY: event.detail.clientY,
      context: {
        draggableId: draggableItem.id,
        droppableId: droppableItem.id,
        draggable: draggableItem.context,
        droppable: droppableItem.context
      }
    });
    this.trigger(Events.DragOver, event);
  }
  onDragLeave(event, droppableElement) {
    if (!this.isDragging) {
      return;
    }
    if (!this.currentDraggableId || !this.currentDroppableId) {
      return;
    }
    let draggableItem = this.draggableMap[this.currentDraggableId];
    let droppableItem = this.droppableMap[this.currentDroppableId];
    triggerEvent(droppableElement, Events.DragLeave, {
      context: {
        draggableId: draggableItem.id,
        droppableId: droppableItem.id,
        draggable: draggableItem.context,
        droppable: droppableItem.context
      }
    });
    this.trigger(Events.DragLeave, event);
    this.currentDroppableId = null;
  }
  onDrop(event, droppableElement) {
    if (!this.currentDraggableId || !this.currentDroppableId) {
      return;
    }
    let draggableItem = this.draggableMap[this.currentDraggableId];
    let droppableItem = this.droppableMap[this.currentDroppableId];
    triggerEvent(droppableElement, Events.Drop, {
      clientX: event.detail.clientX,
      clientY: event.detail.clientY,
      context: {
        draggableId: draggableItem.id,
        droppableId: droppableItem.id,
        draggable: draggableItem.context,
        droppable: droppableItem.context
      }
    });
    this.trigger(Events.Drop, event);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isDragging", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentDraggableId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentDroppableId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "registerDraggable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerDraggable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterDraggable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterDraggable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerDroppable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerDroppable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterDroppable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterDroppable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragMove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragLeave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragLeave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDrop", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDrop"), _class.prototype)), _class);
export { FlyDragDropManager as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.